/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiService } from 'app/api';
import { IApplicationContext } from 'app/context/types';
import { SearchCardsFieldsForm } from '../components/LiveSessionCardsSearchBar';
import {
	ICreateLiveSessionCard,
	ILiveSessionCard,
} from '../interfaces/LiveSessionCard';

export type ILiveSessionCardGetManySearchQuery = SearchCardsFieldsForm & {
	page: number;
};

export class LiveSessionCardService {
	private apiService: ApiService;

	constructor(private applicationContext: IApplicationContext) {
		this.apiService = new ApiService(this.applicationContext);
	}

	searchCategories(searchKey: string) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().LIVE_SESSION_CARD
						.SEARCH_CATEGORIES,
					null,
					{
						pathParams: {
							searchKey,
						},
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				}),
		);
	}

	getCards(searchQuery: ILiveSessionCardGetManySearchQuery) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().LIVE_SESSION_CARD.GET_CARDS,
					null,
					{
						pathParams: this.formGetCardsSearchQuery(searchQuery),
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				}),
		);
	}

	searchCards(searchKey: string) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().LIVE_SESSION_CARD.SEARCH_CARDS,
					null,
					{
						pathParams: { searchKey },
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				}),
		);
	}

	deleteCard(cardId: number) {
		return this.apiService.invoke(
			this.applicationContext.getApiConfig().LIVE_SESSION_CARD.DELETE_CARD,
			null,
			{ reqPathParam: cardId },
		);
	}

	getCard(id: number) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().LIVE_SESSION_CARD.GET_CARD,
					{},
					{
						reqPathParam: id,
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((err: Error) => {
					reject(err);
				}),
		);
	}

	createCard(newCard: ILiveSessionCard) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().LIVE_SESSION_CARD.CREATE_CARD,
					this.formatCardData(newCard),
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				}),
		);
	}

	updateCard(updatedCard: ILiveSessionCard) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().LIVE_SESSION_CARD.UPDATE_CARD,
					this.formatCardData(updatedCard),
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				}),
		);
	}

	private formatCardData(newCard: ILiveSessionCard): ICreateLiveSessionCard {
		const {
			title,
			description,
			customButton,
			showLssButton,
			showOnLss,
			showOnLssAfterLessonComplete,
			redirectURL,
		} = newCard;
		return {
			...(newCard.id ? { id: newCard.id } : {}),
			title,
			description,
			mainImageId: newCard.mainImage.id,
			backgroundImageId: newCard.backgroundImage.id,
			redirectURL,
			customButton,
			showLssButton,
			showOnLss,
			showOnLssAfterLessonComplete,
			...(newCard.lesson ? { lessonId: newCard.lesson.id } : {}),
		};
	}

	private formGetCardsSearchQuery(
		searchQuery: ILiveSessionCardGetManySearchQuery,
	) {
		const formatedSearchQuery: any = { ...searchQuery };
		if (searchQuery.lessonsRegion !== -1) {
			formatedSearchQuery.lessonsRegion = searchQuery.lessonsRegion;
		} else {
			delete formatedSearchQuery.lessonsRegion;
		}

		return formatedSearchQuery;
	}
}
